export const GLOBAL_SEARCH = {
  REGISTER_BOOK_SEARCH_LIST: "/global-search/register-book",
  SCHEDULE_BOOK_SEARCH_LIST: "/global-search/schedule-book",
  CALL_LOG_SEARCH_LIST: "/global-search/call-log",
  COMPLIAN_SEARCH_LIST: "/global-search/complain",
  VISITOR_SEARCH_LIST: "/global-search/visitor",
  VISITOR_ENTRY_SEARCH_LIST: "/global-search/visitor/entry",
  CONNECTOR_SEARCH_LIST: "/global-search/connector",
  KARYAKARTA_SEARCH_LIST: "/global-search/karyakarta",
  ADHIKARI_SEARCH_LIST: "/global-search/adhikari",
};
